var PREFIX = "PROJECT_LAST_MODIFIED.";
export var UPDATE_PROJECT_LAST_MODIFIED_LOCALLY = PREFIX + "UPDATE_PROJECT_LAST_MODIFIED_LOCALLY";
